var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { ValidationCollector } from '@common/types/validationCollector';
import { isNullOrUndefined } from '@common/utils/functions';
import Loader from '@common/vuejs/components/Loader.vue';
import bsCustomFileInput from 'bs-custom-file-input';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { ACTION_TYPE } from '../types/actionType';
import { COMMIT_TYPE } from '../types/commitType';
var AttachmentSelectorComponent = /** @class */ (function (_super) {
    __extends(AttachmentSelectorComponent, _super);
    function AttachmentSelectorComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AttachmentSelectorComponent.prototype.attachmentsChange = function (e) {
        var _this = this;
        this.$store.commit(COMMIT_TYPE.ValidationCollector, null);
        var files = Array.from((e.target.files || e.dataTransfer.files));
        if (isNullOrUndefined(files))
            return;
        var totalFileSizeInBytes = 0;
        files.forEach(function (file) {
            totalFileSizeInBytes += file.size;
            var isOfAllowedType = file.type.length > 0 && _this.allowedMimeTypes.indexOf(file.type) >= 0;
            if (!isOfAllowedType) {
                var validationCollector = new ValidationCollector();
                validationCollector.addError("File '" + file.name + "' with type '" + file.type + "' is not allowed");
                _this.$store.commit(COMMIT_TYPE.ValidationCollector, validationCollector);
                _this.resetAttachments();
                return;
            }
            if (totalFileSizeInBytes > _this.maxTotalFileSizeInBytes) {
                var maxTotalFileSizeInMb = _this.maxTotalFileSizeInBytes / Math.pow(1024, 2);
                var validationCollector = new ValidationCollector();
                validationCollector.addError("Total file size exceeds " + maxTotalFileSizeInMb + " MB");
                _this.$store.commit(COMMIT_TYPE.ValidationCollector, validationCollector);
                _this.resetAttachments();
                return;
            }
        });
        this.registration().attachments = files;
    };
    AttachmentSelectorComponent.prototype.resetAttachments = function () {
        if (this.registration().attachments == null)
            return;
        var attachmentsElement = this.$el.querySelector('#attachments');
        attachmentsElement.value = '';
        bsCustomFileInput.destroy();
        bsCustomFileInput.init();
    };
    AttachmentSelectorComponent.prototype.registration = function () {
        return this.$store.state.registration;
    };
    AttachmentSelectorComponent.prototype.attachmentPath = function (attachmentId) {
        var _a;
        var getAttachmentPath = (_a = this.$store.state.initializationData) === null || _a === void 0 ? void 0 : _a.getAttachmentPath;
        return getAttachmentPath + "?attachmentId=" + attachmentId;
    };
    AttachmentSelectorComponent.prototype.mounted = function () {
        var _this = this;
        bsCustomFileInput.init();
        this.$store.subscribeAction(function (action) {
            if (!(action.type == ACTION_TYPE.Reset || action.type == ACTION_TYPE.ResetMachine))
                return;
            _this.resetAttachments();
        });
    };
    __decorate([
        Prop(),
        __metadata("design:type", String)
    ], AttachmentSelectorComponent.prototype, "allowedMimeTypes", void 0);
    __decorate([
        Prop(),
        __metadata("design:type", Number)
    ], AttachmentSelectorComponent.prototype, "maxTotalFileSizeInBytes", void 0);
    __decorate([
        Prop(),
        __metadata("design:type", Array)
    ], AttachmentSelectorComponent.prototype, "existingAttachments", void 0);
    __decorate([
        Prop(),
        __metadata("design:type", Boolean)
    ], AttachmentSelectorComponent.prototype, "disabled", void 0);
    AttachmentSelectorComponent = __decorate([
        Component({
            name: 'attachment-selector',
            components: {
                Loader: Loader
            }
        })
    ], AttachmentSelectorComponent);
    return AttachmentSelectorComponent;
}(Vue));
export default AttachmentSelectorComponent;
